var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"xid-can-card"},[_c('div',{staticClass:"check-content"},[_c('span',{staticClass:"content"},[_c('img',{staticClass:"check-mark",attrs:{"src":require('@/assets/icons/check.svg')}}),_vm._v(" "+_vm._s(_vm.title)+" ")])]),_c('div',{staticClass:"desc"},[_vm._v(" "+_vm._s(_vm.description)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }